import React, { FunctionComponent, useState, useContext } from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import disclaimerSectionStyles from './disclaimerSectionStyles';
import { useIntl } from 'react-intl';
import GenericAccordion from '../../../../common/components/presentation/genericAccordion/GenericAccordion';
import { CustomiseSections } from '../../../../common/enum/CustomiseSections';
import customise from '../../../constants/customise';
import { PostCodeContext } from '../../../../common/react/PostCodeContext';
import useGetPostCode from '../../../../common/react/useGetPostCode';
import Translation from '../../../../common/components/translation/Translation';

export interface IDisclaimerSectionProps {
  disclaimers: string[];
}

const DisclaimerSection: FunctionComponent<IDisclaimerSectionProps> = ({ disclaimers }) => {
  const { openModal } = useContext(PostCodeContext);
  const postCodeValue = useGetPostCode();
  const styles = disclaimerSectionStyles();
  const [expanded, setExpanded] = useState(true);
  const intl = useIntl();

  const renderPostCode: () => JSX.Element = () => (
    <Typography
      variant="subtitle1"
      component="span"
      className={styles.disclaimerPostcode}
      data-test="text:disclaimer:postcode_modal_cta"
      onClick={() => openModal(true)}
    >
      {postCodeValue} ({intl.formatMessage({ id: 'spc.postcode.change' })})
    </Typography>
  );

  return (
    <Box
      className={styles.disclaimerContainer}
      data-test="customise:disclaimerSection"
      id={`${customise.DOM_ID_PREFIX}${CustomiseSections.DISCLAIMER}`}
    >
      <GenericAccordion
        classes={{
          accordionPaper: styles.disclaimerAccordionPaper,
          accordionSummary: styles.disclaimerAccordionSummary,
          accordionDetails: styles.disclaimerAccordionDetails,
        }}
        summary={
          <Typography className={styles.disclaimerTitle}>
            <Translation id="spc.customise.disclaimer.title" />
          </Typography>
        }
        details={
          <>
            {/* RDP price disclaimer should be first */}
            <Typography
              variant="subtitle1"
              className={styles.disclaimerBody}
              data-test={'customise:disclaimer:rdp'}
              component="p"
            >
              <Translation
                id={'spc.customise.disclaimer.rdp'}
                values={{
                  postcodeValue: renderPostCode(),
                  a: (label: string) => (
                    <Link
                      variant={'subtitle1'}
                      target="_blank"
                      href={intl.formatMessage({ id: 'spc.customise.disclaimer.rdpLink' })}
                    >
                      {label}
                    </Link>
                  ),
                }}
              />
            </Typography>

            {disclaimers.map((elem, index) => (
              <Typography
                variant="subtitle1"
                className={styles.disclaimerBody}
                key={index}
                data-test={`customise:disclaimer:${index}`}
                dangerouslySetInnerHTML={{ __html: elem }}
                component="p"
              />
            ))}
          </>
        }
        expanded={expanded}
        setExpanded={setExpanded}
      />
    </Box>
  );
};

export default DisclaimerSection;
